export default "__VITE_ASSET__bixSadYE__"